export function useScrollTo() {
    $(document).on("click", ".scroll-top", (e) => {
        e.preventDefault();
        $("html,body").animate({ scrollTop: 0 }, 700);
    });

    $(".scroll-to").click(function (e) {
        e.preventDefault();
        const targetSelector = $(this).attr("href");
        scrollToAnimated(targetSelector);
    });

    $(".scroll-to-bottom").click(function (e) {
        e.preventDefault();
        const targetSelector = $(this).attr("href");
        scrollToBottomAnimated(targetSelector);
    });

    // scroll on page load
    if (location.hash?.indexOf("#scroll-") >= 0) {
        const selector = getScrollSelectorFromHash(location.hash);

        scrollToAnimated(selector, -90);
        // sometimes it jumps back to page start
        setTimeout(() => {
            scrollToAnimated(selector, -90);
        }, 100);
    }

    $('a[href*="#scroll-"]').click((e) => {
        const selector = getScrollSelectorFromHash($(e.currentTarget).attr("href"));
        scrollToAnimated(selector);
    });
}

export function scrollToAnimated(selector: string, offsetY = 80) {
    const target = document.querySelector<HTMLElement>(selector);
    scrollToElAnimated(target, offsetY);
}

export function scrollToElAnimated(element: HTMLElement, offsetY = 80) {
    if (!element) {
        return;
    }

    window.scroll({ top: window.scrollY + element.getBoundingClientRect().y - offsetY, behavior: "smooth" });
}

export function scrollToBottomAnimated(selector: string) {
    const target = $(selector).eq(0);

    if (target.length) {
        $("html,body").animate(
            {
                scrollTop: target.offset().top + target.outerHeight() - 80, // fixed header and some extra space
            },
            700
        );
    }
}

function getScrollSelectorFromHash(urlWithHash: string) {
    const hash = /.*#scroll-(?<hash>.*)/.exec(urlWithHash).groups?.hash;
    if (!hash) {
        return;
    }
    return `#${hash}`;
}
